import {Injectable} from '@angular/core';
import {TagApi} from '../api/tag.api';
import {CplTag} from '../model/cpl-tag.model';

@Injectable()
export class TagService {
    constructor(private tagApi: TagApi) { }

    getTags = (portalId: number, searchBy: string) => this.tagApi.getTags(portalId, searchBy);

    createTag = (tag: CplTag) => this.tagApi.createTag(tag);

    updateTag = (tag: CplTag) => this.tagApi.updateTag(tag);

    deleteTag = (tag: CplTag) => this.tagApi.deleteTag(tag);
}